import {
  Box,
  Flex,
  Text,
  Icon,
  Grid,
  GridItem,
} from '@chakra-ui/react';
import React from 'react';
import { FiArrowRight } from 'react-icons/fi';

import type { Transaction } from 'types/api/transaction';

import getValueWithUnit from 'lib/getValueWithUnit';
import { currencyUnits } from 'lib/units';
import { Skeleton } from 'toolkit/chakra/skeleton';
import AddressEntity from 'ui/shared/entities/address/AddressEntity';
import TxEntity from 'ui/shared/entities/tx/TxEntity';
import TimeAgoWithTooltip from 'ui/shared/TimeAgoWithTooltip';

type Props = {
  tx: Transaction;
  isLoading?: boolean;
  animation?: string;
};

const LatestTxsItemMobile = ({ tx, isLoading, animation }: Props) => {
  const dataTo = tx.to ? tx.to : tx.created_contract;

  return (
    <Box
      animation={animation}
      borderBottom="1px solid"
      borderColor="gray.100"
      _dark={{ borderColor: "gray.700" }}
      py={3}
      px={{ base: 2, md: 3 }}
    >
      <Grid templateColumns={{ base: "auto 1fr auto" }} gap={1}>
        {/* 交易图标 */}
        {/* <GridItem>
          <Flex justifyContent="center" alignItems="center" height="100%">
            <Icon as={FiArrowRight} color="#6c757d" boxSize={5} />
          </Flex>
        </GridItem> */}

        {/* 交易信息 */}
        <GridItem>
          {/* 第1行：TX哈希和时间 */}
          <Flex justifyContent="space-between" alignItems="center" mb={2}>
            <Text color={{ _light: '#212529', _dark: 'gray.400' }} fontSize="xs" width="35px">TX#</Text>
            <Skeleton loading={isLoading}>

              <TxEntity
                hash={tx.hash}
                isLoading={isLoading}
                fontSize="sm"
                fontWeight={500}
                truncation="constant"
                color="#3498db"
                noIcon
              />
            </Skeleton>
            <Skeleton loading={isLoading} ml={2}>
              <TimeAgoWithTooltip
                timestamp={tx.timestamp}
                enableIncrement={!isLoading}
                fontSize="xs"
                color="#77838f"
              />
            </Skeleton>
          </Flex>

          {/* 第2行：From地址 */}
          <Skeleton loading={isLoading} mb={1}>
            {tx.from && (
              <Flex alignItems="center">
                <Text color={{ _light: '#212529', _dark: 'gray.400' }} fontSize="xs" width="35px">From</Text>
                <AddressEntity
                  address={tx.from}
                  isLoading={isLoading}
                  truncation="constant"
                  fontSize="xs"
                  noCopy
                  noIcon
                  color="#3498db"
                />
              </Flex>
            )}
          </Skeleton>

          {/* 第3行：To地址 */}
          <Skeleton loading={isLoading}>
            {dataTo && (
              <Flex alignItems="center">
                <Text color={{ _light: '#212529', _dark: 'gray.400' }} fontSize="xs" width="35px">To</Text>
                <AddressEntity
                  address={dataTo}
                  isLoading={isLoading}
                  truncation="constant"
                  fontSize="xs"
                  noCopy
                  noIcon
                  color="#3498db"
                />
              </Flex>
            )}
          </Skeleton>
        </GridItem>

        {/* 右侧：交易金额 */}
        <GridItem justifySelf="right" alignSelf="center">
          <Skeleton loading={isLoading}>
            <Box
              bg="gray.50"
              _dark={{ bg: "gray.700", color: "gray.200" }}
              px={2}
              py={0.5}
              borderRadius="md"
              fontSize="xs"
              fontWeight="medium"
              color="#262b2f"
              textAlign="right"
              display="inline-block"
              whiteSpace="nowrap"
            >
              {getValueWithUnit(tx.value).dp(4).toFormat()} {currencyUnits.ether}
            </Box>
          </Skeleton>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default React.memo(LatestTxsItemMobile);
